import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import Style from "../../style/Pages/Accountsummary.module.css";
import { FaRegUser } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import { useTheme } from "../../context/ThemeContext";
import { useFetchAccountSummary } from "../../hooks/useAccountSummary";
import { CiLaptop, CiMobile2 } from "react-icons/ci";
import { TbPointFilled } from "react-icons/tb";
import { getUserDetails } from "../../utils/auth";
import PageLoader from "../../components/ui/Loader/PageLoader";
import formatDate from "../../components/ui/dateFormat";

const AccountSummary = () => {
  //   const [isDarkMode, setIsDarkMode] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const isDarkMode = theme === "dark";
  const { isloading, accountSummary } = useFetchAccountSummary();
  const deviceData = accountSummary.linked_device_details || [];
  const userDetails = getUserDetails();

  const handleThemeToggle = () => {
    setIsAnimating(true);
    toggleTheme(); // This will update the theme in context
    setTimeout(() => setIsAnimating(false), 300); // Optional animation reset
  };

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p>Account Summary</p>
        </div>
      </div>
      <div className={mainStyle.mainContentView} style={{ height: "92%" }}>
        {isloading ? (
          <PageLoader />
        ) : (
          <div className={mainStyle.mainContentViewsb}>
            <div className={Style.dashboardGrid}>
              {/* User Stats Cards */}
              {userDetails.role !== "admin" ? (
                <></>
              ) : (
                <div className={Style.statsSection}>
                  <div className={Style.statsCard}>
                    <div
                      className={Style.statsIcon}
                      style={{ background: "rgba(59, 130, 246, 0.1)" }}
                    >
                      <FaRegUser size={20} style={{ color: "#3b82f6" }} />
                    </div>
                    <div className={Style.statsContent}>
                      <h3>Total Users</h3>
                      <p>{accountSummary?.all_user_count}</p>
                    </div>
                  </div>

                  <div className={Style.statsCard}>
                    <div
                      className={Style.statsIcon}
                      style={{ background: "rgba(16, 185, 129, 0.1)" }}
                    >
                      <FaRegClock size={20} style={{ color: "green" }} />
                    </div>
                    <div className={Style.statsContent}>
                      <h3>Active Users</h3>
                      <p>{accountSummary?.active_user_count}</p>
                    </div>
                  </div>

                  <div className={Style.statsCard}>
                    <div
                      className={Style.statsIcon}
                      style={{ background: "rgb(245 11 11 / 10%)" }}
                    >
                      <FaRegClock size={20} style={{ color: "red" }} />
                    </div>
                    <div className={Style.statsContent}>
                      <h3>Deactive User</h3>
                      <p>{accountSummary?.deactive_user_count}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Theme Settings */}
              <div className={Style.settingsCard}>
                <div className={Style.settingsHeader}>
                  <h3>Theme Preferences</h3>
                  <p>Customize your interface appearance</p>
                </div>

                <div className={Style.themeSelectorContainer}>
                  <div
                    className={`${Style.themeOption} ${
                      !isDarkMode ? Style.activeTheme : ""
                    }`}
                    onClick={() => {
                      if (isDarkMode) handleThemeToggle();
                    }}
                  >
                    <div className={Style.themePreview}>
                      <div className={Style.lightPreview}>
                        <div className={Style.previewHeader}></div>
                        <div className={Style.previewContent}>
                          <div className={Style.previewItem}></div>
                          <div className={Style.previewItem}></div>
                          <div className={Style.previewItem}></div>
                        </div>
                      </div>
                    </div>
                    <div className={Style.themeInfo}>
                      <h4>Light Mode</h4>
                      <p>Clean and bright interface</p>
                    </div>
                    {!isDarkMode && (
                      <div className={Style.activeIndicator}></div>
                    )}
                  </div>

                  <div
                    className={`${Style.themeOption} ${
                      isDarkMode ? Style.activeTheme : ""
                    }`}
                    onClick={() => {
                      if (!isDarkMode) handleThemeToggle();
                    }}
                  >
                    <div className={Style.themePreview}>
                      <div className={Style.darkPreview}>
                        <div className={Style.previewHeader}></div>
                        <div className={Style.previewContent}>
                          <div className={Style.previewItem}></div>
                          <div className={Style.previewItem}></div>
                          <div className={Style.previewItem}></div>
                        </div>
                      </div>
                    </div>
                    <div className={Style.themeInfo}>
                      <h4>Dark Mode</h4>
                      <p>Easy on the eyes in low light</p>
                    </div>
                    {isDarkMode && (
                      <div className={Style.activeIndicator}></div>
                    )}
                  </div>
                </div>

                <div className={Style.toggleContainer}>
                  <div className={Style.toggleSwitch}>
                    <input
                      type="checkbox"
                      id="themeToggle"
                      checked={isDarkMode}
                      onChange={toggleTheme}
                    />
                    <label
                      htmlFor="themeToggle"
                      className={`${Style.toggleSlider} ${
                        isAnimating ? Style.animating : ""
                      }`}
                    >
                      <span className={Style.sunIcon}></span>
                      <span className={Style.moonIcon}></span>
                    </label>
                  </div>
                  <span className={Style.toggleLabel}>
                    {isDarkMode ? "Dark Mode Enabled" : "Light Mode Enabled"}
                  </span>
                </div>
              </div>

              {/* Login Devices */}
              <div className={Style.devicesCard}>
                <div className={Style.cardHeader}>
                  <h3>Login Devices</h3>
                  <p>Devices that have accessed your account</p>
                </div>

                <div className={Style.devicesList}>
                  <div className={Style.devicesHeader}>
                    <span>Device</span>
                    <span>Time</span>
                    <span>Last Activity</span>
                    <span>Status</span>
                  </div>
                  <div className={Style.deviceItemsContainer}>
                    {deviceData.map((device) => (
                      <div key={device.id} className={Style.deviceItem}>
                        <div className={Style.deviceInfo}>
                          <div className={Style.deviceIcon}>
                            {device?.device_name.includes("App") ? (
                              <CiMobile2
                                size={20}
                                className={Style.webMobileIcon}
                              />
                            ) : (
                              <CiLaptop
                                size={20}
                                className={Style.webMobileIcon}
                              />
                            )}
                          </div>
                          <div>
                            <div className={Style.deviceName}>
                              {device.device_name}
                            </div>
                          </div>
                        </div>
                        <div className={Style.deviceTime}>
                          {device.create_time}
                        </div>
                        <div className={Style.deviceTime}>
                          {formatDate(device.create_date)}
                        </div>
                        <div className={Style.deviceStatus}>
                          <span
                            className={`${Style.statusBadge} ${Style.activeStatus}
                      )}`}
                          >
                            <div className={Style.activeIcon}>
                              <TbPointFilled size={20} />
                            </div>{" "}
                            Active
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={Style.cardFooter}></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default AccountSummary;
